<script>
  import { dispatchCustomEvent, SEARCH } from "$lib/utils/events";
  import { bodyScroll } from "$lib/utils/PreventBodyScroll";
  import Loader from "../Loader.svelte";
  import CardProducts from "../products/CardProducts.svelte";

  /**@type {HTMLDialogElement}*/
  let modal;
  /**@type {string}*/
  let searchTerm;
  /**@type {number}*/
  let timeOut;
  /**@type {HTMLInputElement}*/
  let searchInput;
  let signalController = new AbortController();
  /**@type {import ('$lib/types').PublicProduct[] | ??}*/
  let searchResults = null;
  let searchInProgress = false;

  const search = async () => {
    searchInProgress = true;
    clearTimeout(timeOut);
    if (searchInput?.value?.length < 1) {
      if (searchInProgress) {
        signalController?.abort();
      }
      searchResults = [];
      return;
    }
    try {
      timeOut = setTimeout(async () => {
        if (searchInProgress) {
          signalController?.abort();
          signalController = new AbortController();
        }
        let fetchSearch = await fetch(`/search?q=${searchTerm}`, {
          signal: signalController?.signal,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const response = await fetchSearch.json();
        if (fetchSearch.status == 200) {
          dispatchCustomEvent(SEARCH, searchTerm);
          searchResults = response;
          searchInProgress = false;
        }
      }, 500);
    } catch (error) {
      console.log(error);
    }
  };
  /**@param {*}e*/
  const closeByBackdrop = (e) => {
    let rect = e.target.getBoundingClientRect();
    if (
      rect.left > e.clientX ||
      rect.right < e.clientX ||
      rect.top > e.clientY ||
      rect.bottom < e.clientY
    ) {
      modal.close();
      bodyScroll.allow();
    }
  };
  const openSearch = () => {
    modal.showModal();
    bodyScroll.prevent();
    searchInput.select();
  };
</script>

<button on:click={openSearch} class="search">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.134 26.957">
    <g
      id="Grupo_291"
      data-name="Grupo 291"
      transform="translate(-4159.75 -10619)"
    >
      <g
        id="Elipse_12"
        data-name="Elipse 12"
        transform="translate(4159.75 10619)"
        fill="var(--global)"
        stroke="var(--global)"
        stroke-width="3"
      >
        <circle cx="8.026" cy="8.026" r="8.026" stroke="none" />
        <circle cx="8.026" cy="8.026" r="6.526" fill="none" />
      </g>
      <line
        id="Línea_22"
        data-name="Línea 22"
        x2="6.622"
        y2="10.166"
        transform="translate(4171.187 10633.715)"
        fill="none"
        stroke="var(--global)"
        stroke-linecap="round"
        stroke-width="3"
      />
    </g>
  </svg>
</button>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog bind:this={modal} on:click={(e) => closeByBackdrop(e)}>
  <button on:click={() => modal.close()}>X</button>
  <form on:submit|preventDefault={search}>
    <div class="search-input">
      <input
        type="text"
        bind:this={searchInput}
        bind:value={searchTerm}
        on:keyup|preventDefault={search}
        placeholder="search"
      />
      <svg
        id="Grupo_291"
        data-name="Grupo 291"
        xmlns="http://www.w3.org/2000/svg"
        width="47.686"
        height="64.918"
        viewBox="0 0 47.686 64.918"
      >
        <g
          id="Elipse_12"
          data-name="Elipse 12"
          transform="translate(0)"
          fill="var(--global)"
          stroke="var(--global)"
          stroke-width="3"
        >
          <ellipse
            cx="20.272"
            cy="20.272"
            rx="20.272"
            ry="20.272"
            stroke="none"
          />
          <ellipse
            cx="20.272"
            cy="20.272"
            rx="18.772"
            ry="18.772"
            fill="none"
          />
        </g>
        <line
          id="Línea_22"
          data-name="Línea 22"
          x2="16.724"
          y2="25.677"
          transform="translate(28.887 37.166)"
          fill="none"
          stroke="var(--global)"
          stroke-linecap="round"
          stroke-width="3"
        />
      </svg>
    </div>
  </form>
  <div class="results">
    {#if searchInProgress}
      <Loader />
    {:else}
      <div class="container-products">
        {#if searchResults?.length > 0 && searchResults}
          {#each searchResults as result}
            <li on:click={() => modal.close()}>
              <CardProducts product={result} />
            </li>
          {/each}
        {:else if searchResults}
          <p>Products not found for {searchTerm || ""}</p>
        {/if}
      </div>
    {/if}
  </div>
</dialog>

<style>
  .search {
    width: 1.8rem;
    height: 2.4rem;
    margin-top: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
  }
  .search svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  dialog {
    width: 100svw;
    max-width: 180rem;
    overflow: hidden;
    max-height: 90svh;
    height: 100%;
    background-color: var(--white);
    border: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 2rem;
    padding: 5rem;
    position: fixed;
  }
  dialog button {
    border: none;
    background: none;
    font-family: "genty";
    color: var(--global);
    font-size: 2rem;
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
  }
  form input {
    padding: 1rem 0;
    text-align: left;
    text-indent: 3rem;
  }
  .search-input {
    position: relative;
    padding: 1rem 0;
  }
  .search-input svg {
    position: absolute;
    width: 1.5rem;
    left: 2px;
    top: 0;
  }
  .results {
    padding: 2rem 0 0 0;
    overflow: hidden;
    width: 100%;
    height: 95%;
  }
  .container-products {
    display: grid;
    grid-template-columns: repeat(auto-fill, 350px);
    justify-content: center;
    gap: 1rem;
    overflow-y: scroll;
    height: 100%;
    width: 100%;
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
  }
  .container-products p {
    font-size: 2rem;
    font-weight: 700;
    color: var(--global);
  }
  .container-products li {
    list-style: none;
  }
  @media (max-width: 768px) {
    .container-products {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 767px) {
    .container-products {
      grid-template-columns: 1fr;
    }
  }
</style>
